import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FlowTypeService {

    constructor() {
    }

    get state() {
        return localStorage.getItem('flowType')  || '';
    }

    set state(prop: string) {
        localStorage.setItem('flowType', prop);
    }
}
